<template>
  <div :class="{'nav-open': $sidebar.showSidebar}" 
  v-loading.fullscreen.lock="$loading" 
  :element-loading-text="$loadingText"
  >
    <notifications transition-name="notification-list" transition-mode="out-in">

    </notifications>
    <router-view name="header"></router-view>
    <transition name="fade"
                mode="out-in">
      <router-view></router-view>
    </transition>
    <router-view name="footer"></router-view>

    <div  v-if="mode != 'production'" style="padding: 10px; z-index: 999;text-align: center; background: red; height: 50px; color: white; position: fixed; bottom: 0px; width: 100%;">
      {{  mode.toUpperCase() }}
      <div>FOR TESTING ONLY</div>
    </div>
  </div>
</template>

<script>
  // Loading some plugin css asynchronously
  import 'sweetalert2/dist/sweetalert2.css'
import 'vue-notifyjs/themes/default.css'

export default {
  data() {
    return {
      config: process.env.VUE_APP_TEST,
      mode: process.env.VUE_APP_MODE
    };
  },
  created: function () {}
  }
</script>
<style lang="scss">
  .vue-notifyjs .alert {
    z-index: 99999 !important;
  }
  .red-label{
    color: #dc3545 !important;
  }
</style>
